import React from 'react';
import get from 'lodash/get';
import nlData from './newsletters_page_data';
import NewsletterSubscriber from '../../../components/newsletter_subscriber/newsletter_subscriber';

class NewslettersPageForm extends NewsletterSubscriber {
  render() {
    return (
      <div>

        <form onSubmit={this.handleSubmit}>
          <p className="newsletter-page__input-group">
            <input
              type="email"
              id="email"
              className="newsletter-signup__input newsletter-signup__input--nl-page"
              placeholder={
                get(this.statusMessages, [this.state.status]) ||
                'YOUR EMAIL ADDRESS'
              }
              onChange={this.handleEmailUpdate}
              value={this.state.email}
              disabled={this.state.disabled}
            />
            <label className="visually-hidden" htmlFor="email">Email</label>
            <button
              className="newsletter-signup__button newsletter-signup__button--nl-page"
              type={this.state.disabled ? 'button' : 'submit'}
            >
              Send
            </button>
          </p>
          <h2 className="newsletter-page__grouping-label">Sites</h2>
          <div className="site-row">
            {nlData.sites.map(siteData =>
              <div
                className="newsletter-page__grouping"
                key={siteData.siteLogo}
              >
                <h3 className="newsletter-page__site">
                  <img
                    alt={siteData.siteName}
                    className="newsletter-page__site-logo"
                    src={siteData.siteLogo}
                  />
                  <span className="newsletter-page__site-copy">
                    <span className="newsletter-page__site-name">
                      {siteData.siteName}
                    </span>
                    <span className="newsletter-page__site-desc">
                      {siteData.siteDesc}
                    </span>
                  </span>
                </h3>
                <div style={{ display: 'flex', marginTop: '10px' }}>

                  {siteData.options.map(option =>
                    <div className="half-width" key={option.value}>
                      <input
                        onChange={this.handleUpdate}
                        type="checkbox"
                        className="newsletter-page__check"
                        id={option.value}
                        name={option.value}
                        checked={this.state.newsletters[option.value]}
                      />
                      <label
                        className="newsletter-signup__copy--smaller"
                        htmlFor={option.value}
                      >
                        {option.name}
                      </label>
                    </div>
                  )}

                </div>
              </div>
            )}
          </div>
          <h2 className="newsletter-page__grouping-label">Daily</h2>
          <div className="site-row">

            {nlData.daily.map(nl =>
              <p key={nl.value} className="newsletter-page__table-cell">
                <input
                  type="checkbox"
                  onChange={this.handleUpdate}
                  id={nl.value}
                  name={nl.value}
                  checked={this.state.newsletters[nl.value]}
                />
                <label
                  className="newsletter-page__site-name"
                  htmlFor={nl.value}
                >
                  {nl.name}
                </label>
                <span className="newsletter-page__desc">
                  {nl.desc}
                </span>
              </p>
            )}

          </div>

          <h2 className="newsletter-page__grouping-label">Weekly</h2>
          <div className="site-row">

            {nlData.weekly.map(nl =>
              <p key={nl.value} className="newsletter-page__table-cell">
                <input
                  type="checkbox"
                  onChange={this.handleUpdate}
                  id={nl.value}
                  name={nl.value}
                  checked={this.state.newsletters[nl.value]}
                />
                <label
                  className="newsletter-page__site-name"
                  htmlFor={nl.value}
                >
                  {nl.name}
                </label>
                <span className="newsletter-page__desc">
                  {nl.desc}
                </span>
              </p>
            )}

          </div>
          <h2 className="newsletter-page__grouping-label">Promotions</h2>
          <div className="site-row">
            {nlData.promotions.map(nl =>
              <p key={nl.value} className="newsletter-page__table-cell">
                <input
                  type="checkbox"
                  onChange={this.handleUpdate}
                  id={nl.value}
                  name={nl.value}
                  checked={this.state.newsletters[nl.value]}
                />
                <label
                  className="newsletter-page__site-name"
                  htmlFor={nl.value}
                >
                  {nl.name}
                </label>
                <span className="newsletter-page__desc">
                  {nl.desc}
                </span>
              </p>
            )}
          </div>
        </form>
      </div>
    );
  }
}

export default NewslettersPageForm;



// WEBPACK FOOTER //
// ./src/views/containers/pages/newsletters_page/newsletters_page_form.js